import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Typography } from '@material-ui/core';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';
import Adobe from '../../adobe';
import Codat from '../../codat';
import Datafiniti from '../../datafiniti';
import Fusionfabric from '../../fusionfabric';
import Hubspot from '../../hubspot';
import OpenWeatherMap from '../../openweathermap';
import Paymi from '../../paymi';
import Radario from '../../radario';
import Roostify from '../../roostify';
import Salesforce from '../../salesforce';
import Sensibill from '../../sensibill';

class Integration extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        {this.getIntegrationView()}
      </div>
    );
  }
  private getIntegrationView = () => {
    switch (this.props.match.params.integrationid) {
      case 'salesforce':
        return <Salesforce />
      case 'codat':
        return <Codat />
      case 'datafiniti':
        return <Datafiniti />
      case 'paymi':
        return <Paymi />
      case 'radario':
        return <Radario />
      case 'hubspot':
        return <Hubspot />
      case 'adobe':
        return <Adobe />
      case 'sensibill':
        return <Sensibill />
      case 'roostify':
        return <Roostify />
      case 'fusionfabric':
        return <Fusionfabric />
      case 'openweathermap':
        return <OpenWeatherMap />
      default:
        return <Typography>
          Unsupported integration.
        </Typography>
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Integration)));



// WEBPACK FOOTER //
// ./src/sub-projects/integration/containers/content.tsx